export enum WorkflowType {
    OnlineJob,
    Task,
    ScheduledMail,
    EventMail,
    TriggerAction
}
